import React, { Component } from "react";
import { connect } from "react-redux";
import { Router, Switch, Route ,Redirect} from "react-router-dom";

import "./App.css";

import Login from "./components/login.component";
import Dashboard from "./components/dashboard.component";
import { logout } from "./actions/auth";
import { clearMessage } from "./actions/message";
import { history } from './helpers/history';
import CreateWallet from "./components/CreateWallet-component";
import NotFound from './components/NotFound.component';
import Wallet from "./components/wallet-component";
import intro from "./components/intro-component";
import TransactionHistory from "./components/transactionhistory.component";
import PaymentBox from "./components/paymentbox-component";
import ThemeToggle from "./components/ThemeToggle.component";
import MobileInstallPrompt from "./components/MobileInstallPrompt.component";

function getCookie(name) {
  const prefix = `${name}=`;
  const cookie = document.cookie.split(";").map((item) => item.trim()).find((item) => item.indexOf(prefix) === 0);
  return cookie ? decodeURIComponent(cookie.substring(prefix.length)) : undefined;
}


class App extends Component {
  constructor(props) {
    super(props);    
    this.logOut = this.logOut.bind(this);
    this.state = {
      currentUser: undefined,
      issintro :undefined
      
    };
    history.listen((location) => {
      props.dispatch(clearMessage()); // clear message when changing location
    });
  }

  componentDidMount() {
    const user = this.props.user;
    var  isintro = getCookie("novaintro");

    console.log(isintro);
    
    this.setState({
      issintro: isintro,
    });
    

    if (user) 
    {
      if( sessionStorage.getItem('sess_id'))
      {
        this.setState({
          currentUser: user,
        });
      }
   }

   else
   {
    return <Redirect to="/login" />;
   }
}

  logOut() {
    this.props.dispatch(logout());
  }

  render() {
    return (
      <Router history={history}>
        <div>
          <ThemeToggle />
          <MobileInstallPrompt />
          <Switch>
              { 
               !this.state.issintro ?
               <Route exact path={["/", "/intro"]} component={intro} />
               :
               <Route exact path={["/", "/login"]} component={Login} />
              }
              <Route path="/login" component={Login} />
              <Route path="/dashboard/:coin?" component={Dashboard} />
              <Route path="/wallet/:coin?" component={Wallet}  />
              <Route path="/transaction/:coin?" component={TransactionHistory} />
              <Route path="/create-wallet" component={CreateWallet} />
              <Route path="/PaymentBox" component={PaymentBox} />

              
              <Route path="*" component={NotFound} />
          </Switch>
        </div>
      </Router>
     );
  }
}

function mapStateToProps(state) {
  const { user } = state.auth;
  return {
    user,
  };
}

export default connect(mapStateToProps)(App);
